import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CollectionApiClient, IPaginationResponse } from '../../../common';
import { ICreateVehicleRequest, IUpdateVehicleRequest, IVehicleLookupsResponse, IVehicleResponse, IVehiclesBasePaginationParameters } from '../dtos';
import { ICheckVehicleExistenceRequest } from '../dtos/requests/check-vehicle-existence.request';
import { IVehicleExistenceResponse } from '../dtos/responses/vehicle-existence.response';
import { IVehiclesApiClient } from './i-vehicles-api.client';
import { vehiclesData } from '../data';

@Injectable({
  providedIn: 'root'
})
export class VehiclesInMemoryApiClient implements IVehiclesApiClient {
  getCollectionApiClient(): CollectionApiClient {
    throw new Error(`Not Supported in in memory clients`);
  }

  getById(id: string): Observable<IVehicleResponse> {
    return of(vehiclesData.vehicleResponse);
  }

  lookups(): Observable<IVehicleLookupsResponse> {
    return of(vehiclesData.lookups);
  }

  lookupsPublic(): Observable<IVehicleLookupsResponse> {
    return of(vehiclesData.lookups);
  }

  update(id: string, request: IUpdateVehicleRequest): Observable<void> {
    return of();
  }

  getMyVehicles(paginationParameters?: IVehiclesBasePaginationParameters): Observable<IPaginationResponse<IVehicleResponse>> {
    return of(vehiclesData.vehiclesResponse);
  }

  getMyVehicleById(id: string): Observable<IVehicleResponse> {
    return of(vehiclesData.vehicleResponse);
  }

  createMyVehicle(request: ICreateVehicleRequest): Observable<IVehicleResponse> {
    return of(vehiclesData.vehicleResponse);
  }

  updateMyVehicle(id: string, request: IUpdateVehicleRequest): Observable<void> {
    return of();
  }

  getPublicVehicles(paginationParameters?: IVehiclesBasePaginationParameters): Observable<IPaginationResponse<IVehicleResponse>> {
    return of(vehiclesData.vehiclesResponse);
  }

  checkExistence(request: ICheckVehicleExistenceRequest): Observable<IVehicleExistenceResponse> {
    return of({ exists: false });
  }
}
